/**
 * Host do placeholder de build de `spassuCode.worker.link` no app-config.yaml
 * (`https://spassuti.sharepoint.com/:u:/s/ProgramadeInovaoSpassu/IQCGxvrrCjzrRLEEubbwqh91AZjxSMAtoEwJyjUew_2qSS4?e=cdd76b`). O `docker/entrypoint-app.sh` troca esse
 * literal no bundle pela variável `WORKER_DOWNLOAD_LINK`; quando ela não está
 * definida, o placeholder sobrevive e a tela deve tratá-lo como "não
 * configurado". A comparação é SÓ pelo host, sem o `https://`: o `sed` do
 * entrypoint casa a URL completa, e um literal completo aqui também seria
 * substituído, escondendo o link real.
 */
const WORKER_DOWNLOAD_LINK_PLACEHOLDER_HOST = 'worker.download.link';

function isPlaceholderLink(link: string): boolean {
  try {
    return new URL(link).hostname === WORKER_DOWNLOAD_LINK_PLACEHOLDER_HOST;
  } catch {
    return false;
  }
}

/** Link de download configurado de fato, ou `undefined` (ausente ou placeholder). */
export function resolveWorkerDownloadLink(
  configured: string | undefined,
): string | undefined {
  if (!configured || isPlaceholderLink(configured)) {
    return undefined;
  }
  return configured;
}
